import { useEntitiesContext } from 'entities/EntitiesExport'
import { eventEmitterStore, useEventEmitter } from 'entities/EventEmitter'

export const useEventTermlyUserCheckLoggedIn = () => {
  const { usersStore } = useEntitiesContext()

  const defaultHandler = () => {
    if (!usersStore.user) return

    eventEmitterStore.emit('termly_user_init_logged_in', usersStore.user.id)
  }

  useEventEmitter('termly_user_check_logged_in', defaultHandler, [usersStore.user])
}
